import { theme as WebComponentsTheme } from '@acorns/web-components'
import { path as getForPath } from 'ramda'

export const theme = (path: string) => (props: any) =>
  getForPath(path.split('.'), props.theme) as string | number

export const style = (cb: (theme: typeof themeObj) => any) => (props: any) =>
  cb(props.theme)

// Leaving this in for backwards compatibility. Should be removed in the future.
const styles = {
  smallBorderRadius: '4px',
  mediumBorderRadius: '8px',
  borderRadius: '10px',
}

const themeObj = {
  ...WebComponentsTheme,
  styles,
}

export type ThemeProps = {
  theme: typeof themeObj
}

export default themeObj
